import {effectDragProps} from './studio-drag.js';
import './studio-refinements.css';

const COLORS=['#fff9ef','#ebc7b8','#dba8a6','#f2b4cf','#bd6b83','#9d233a','#682532','#ca5631','#9b674c','#563b32','#b8c789','#d1ed43','#5e8299','#827bb4','#b8a2c9','#25232a'];
export default function StudioColorPicker({value,secondary,onEffect}) {
 const action=color=>({kind:'solid-color',color,secondary});
 return <section className="st-solid-picker" aria-label="纯色选择">
  <div className="st-solid-swatches">{COLORS.map(color=><button type="button" key={color} aria-label={`纯色 ${color}`} aria-pressed={value?.toLowerCase()===color} style={{'--solid-color':color,backgroundColor:color}} {...effectDragProps(action(color))} onClick={()=>onEffect(action(color))}/>)}</div>
  <label className="st-solid-custom"><span>自定义纯色</span><input type="color" aria-label="自定义纯色" value={/^#[0-9a-f]{6}$/i.test(value||'')?value:'#dba8a6'} onChange={e=>onEffect(action(e.target.value))}/></label>
 </section>;
}
